import React, { useState } from 'react';
import { updateUserPassword } from '../../../helper/HospitalUserCredentialsHelper';
import PasswordInput from '../../../components/PasswordInput/PasswordInput';

const ForgotPasswordModal = ({ user, onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUpdate = () => {
    if (loading) return;

    if (!password.trim()) {
      setError('Please enter a new password');
      return;
    }

    setLoading(true);
    setError('');

    updateUserPassword({ userId: user.id, password: password.trim() })
      .then((response) => {
        const message =
          response?.data?.message ||
          response?.message ||
          'Password updated successfully!';
        onSuccess(message);
      })
      .catch((err) => {
        setError(typeof err === 'string' ? err : 'Failed to update password');
        setLoading(false);
      });
  };

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="forgot-password-title">
      <div className="backdrop" onClick={onClose} aria-hidden="true" />
      <div className="modal-content">
        <h2 id="forgot-password-title">Enter New Password</h2>
        {user?.name ? (
          <p className="hospital-credentials-modal-user">
            {user.name} ({user.email})
          </p>
        ) : null}
        <div className="input-group">
          <PasswordInput
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              if (error) setError('');
            }}
            placeholder="New password"
            autoFocus
          />
          {error ? <p className="error">{error}</p> : null}
        </div>
        <div className="actions">
          <button type="button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button type="button" onClick={handleUpdate} disabled={loading}>
            {loading ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
